import Skeleton from '@/components/ui/Skeleton'

/**
 * Layout-mimicking skeleton for the Directory page — stat strip, search,
 * then cottage-card grid.
 */
const DirectorySkeleton = () => {
  return (
    <div className="space-y-10 animate-fade-in">
      <section className="heritage-card-bordered">
        {/* Section header */}
        <Skeleton className="h-4 w-36 mb-2" />
        <Skeleton className="h-7 w-2/3 mb-3" />
        <Skeleton shape="text" className="w-4/5" />

        {/* Stat strip — 2-up mobile, 5-up large desktop, matches CottageDirectory */}
        <div className="mt-6 grid grid-cols-2 lg:grid-cols-5 gap-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="rounded-2xl border border-mist/50 bg-white p-3 sm:p-4 text-center">
              <Skeleton className="h-8 w-12 mx-auto mb-2" />
              <Skeleton className="h-3 w-16 mx-auto" />
            </div>
          ))}
        </div>

        {/* Search + filter chips */}
        <div className="mt-6 flex flex-wrap gap-3 items-center">
          <Skeleton className="h-10 flex-1 min-w-[16rem] rounded-full" />
          <div className="flex flex-wrap gap-2">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} className="h-10 w-28 rounded-full" />
            ))}
          </div>
        </div>

        {/* Cottage card grid */}
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <article key={i} className="rounded-2xl border border-mist/50 bg-white p-5">
              <div className="flex items-start justify-between gap-3 mb-3">
                <div className="min-w-0 flex-1">
                  <Skeleton className="h-7 w-16 mb-2" />
                  <Skeleton className="h-4 w-32" />
                </div>
                <Skeleton className="h-5 w-14 rounded-full" />
              </div>
              <div className="space-y-2">
                <Skeleton shape="text" className="w-3/4" />
                <Skeleton shape="text" className="w-1/2" />
              </div>
              <div className="mt-4 pt-3 border-t border-mist/40">
                <Skeleton className="h-4 w-24" />
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  )
}

export default DirectorySkeleton
